import React from "react";

interface SocialProp {
  link: string;
  id: number;
  label: string;
  iconClass: string;
}

let socials: Array<SocialProp> = [
  {
    link: "https://instagram.com",
    id: 1,
    label: "Instagram",
    iconClass: "fab fa-instagram",
  },
  {
    link: "https://facebook.com",
    id: 2,
    label: "Facebook",
    iconClass: "fab fa-facebook-f",
  },
  {
    link: "https://twitter.com",
    id: 3,
    label: "Twitter",
    iconClass: "fab fa-twitter",
  },
  {
    link: "https://youtube.com",
    id: 4,
    label: "Youtube",
    iconClass: "fab fa-youtube	",
  },
];

const SocialIcons: React.FC<{ color: string; position: string }> = ({
  color,
  position,
}) => {
  return (
    <ul className={`d-flex justify-content-${position}`}>
      {socials.map((social, index) => {
        return (
          <li className="mx-2" key={index}>
            <a href={social.link} className={color}>
              <i className={social.iconClass}></i>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialIcons;
